import { RelatedProduct } from 'models/RelatedProduct';
import styles from './addToCartHover.scss';
import { Section } from 'components/Section';
import { TrackedElement, useIntersectionObserver } from 'hooks/useIntersectionObserver';
import { IRelatedProduct } from 'models/BasicProduct';
import { Cell, Grid } from 'components/Grid';
import { AccessoryItem } from 'views/ProductPage/accessories/accessoryItem';
import { GtmItemProduct } from 'store/googleTagManager/types';
import { hasElements, NO_ELEMENT, rm } from 'utils';
import {
  getAccessoryListName,
  getCartRecommendationListName,
  mapRelatedProductToGtm
} from 'store/googleTagManager/events/utils';
import { GtmSelectItem, GtmViewListItem } from 'store/googleTagManager/actions';
import { useDispatch } from 'react-redux';

const getListName = (listTitle: string, product: IRelatedProduct): string => {
  if (listTitle === rm('cart_hover_section_accessories')) {
    return getAccessoryListName(product);
  } else {
    return getCartRecommendationListName(product.productId, product.title);
  }
};

type AccessoryItemListProps = {
  products: RelatedProduct[];
  setDrawerState: (value: boolean) => void;
  title: string;
};

export const AccessoryItemList = ({ products, setDrawerState, title }: AccessoryItemListProps) => {
  const reduxDispatch = useDispatch();
  const { setElementRef } = useIntersectionObserver<RelatedProduct>({
    onBatchVisible: handleElementsVisible
  });

  const handleGtmOnClick = (product: IRelatedProduct, index: number) => {
    const gtmItemProduct = mapRelatedProductToGtm({
      product,
      indexInList: index,
      listName: getListName(title, product)
    });

    reduxDispatch(GtmSelectItem({ gtmItemProduct }));
  };

  function handleElementsVisible(elements: TrackedElement<RelatedProduct>[]) {
    const items: GtmItemProduct[] = elements.map(element => {
      const viewedProduct = element.payload;
      const index = products.indexOf(viewedProduct);

      return mapRelatedProductToGtm({
        product: viewedProduct,
        indexInList: index,
        listName: getListName(title, viewedProduct)
      });
    });

    reduxDispatch(GtmViewListItem({ gtmItemProducts: items }));
  }

  if (!hasElements(products)) {
    return NO_ELEMENT;
  }

  return (
    <Section className={styles.section} title={title}>
      <Grid phone="1" gutters="extraLarge">
        {products.map((product, index) => (
          <Cell key={product.productId}>
            <AccessoryItem
              ref={node => setElementRef({ ref: node, payload: product })}
              onDrawerClick={setDrawerState}
              gtmListName={title}
              gtmOnItemClick={product => handleGtmOnClick(product, index)}
              {...product}
            />
          </Cell>
        ))}
      </Grid>
    </Section>
  );
};
